import React from "react";

const DashboardSection = () => {
  return <div>Info Section</div>;
};

export default DashboardSection;
